var _defs, _defs2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiscover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "id_svgCanvas",
    x: "0px",
    y: "0px",
    width: "32px",
    height: "32px",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "5772181592_SVGID_1__focus",
    d: "M0,21c0-2.206,1.794-4,4-4h56c2.205,0,4,1.794,4,4v22c0,2.205-1.795,4-4,4H4c-2.206,0-4-1.795-4-4V21z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#5772181592_SVGID_1__focus",
    style: {
      overflow: "visible",
      fill: "#DEDCD9"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "5772181592_SVGID_2__focus"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#5772181592_SVGID_1__focus",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st5",
    style: {
      clipPath: "url(#5772181592_SVGID_2__focus)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2,37V27h3c2.757,0,5,2.243,5,5s-2.243,5-5,5H2z M8,32c0-1.654-1.346-3-3-3H4v6h1C6.654,35,8,33.654,8,32z     M13,27h-2v10h2V27z M20.388,34c0-1.362-1.045-2.357-3.107-2.96C16,30.666,16,30.233,16,30c0-0.664,0.336-1,1-1    c0.881,0,1.642,0.713,1.645,0.716l1.396-1.432C19.907,28.153,18.677,27,17,27c-1.766,0-3,1.233-3,3c0,1.437,0.915,2.433,2.72,2.96    c1.06,0.31,1.668,0.688,1.668,1.04c0,0.473-0.665,1-1.618,1c-1.04,0-1.938-0.751-1.947-0.759l-1.306,1.515    C13.663,35.883,15.002,37,16.77,37C18.765,37,20.388,35.654,20.388,34z M21,32c0,2.757,2.243,5,5,5    c0.864,0,1.665-0.24,2.375-0.628v-2.561C27.826,34.529,26.971,35,26,35c-1.654,0-3-1.346-3-3s1.346-3,3-3    c0.971,0,1.826,0.471,2.375,1.188v-2.561C27.665,27.24,26.864,27,26,27C23.243,27,21,29.243,21,32z M48.441,27h-2.156    l-2.701,6.583L40.882,27h-2.167l4.104,10h1.519L48.441,27z M54,27h-5v10h5v-2h-3v-2h3v-2h-3v-2h3V27z M57.456,33l2.593,4h2.384    l-2.658-4.101C61.055,32.557,62,31.387,62,30c0-1.654-1.346-3-3-3h-4v10h2v-4H57.456z M57,29h2c0.552,0,1,0.449,1,1s-0.448,1-1,1    h-2V29z",
    style: {
      fill: "#47475E"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "43.533,17 0,17 0,47 26.213,47   ",
    style: {
      fill: "#FFFFFF",
      fillOpacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "5772181592_SVGID_3__focus",
    d: "M39,32c0-2.757-2.242-5-5-5s-5,2.243-5,5c0,2.758,2.242,5,5,5S39,34.758,39,32z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "5772181592_SVGID_5__focus",
    d: "M29,37h3.688c-2.294-1.411-3.072-4.402-1.718-6.75c1.379-2.388,4.44-3.21,6.829-1.83L38,27h-9V37z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "5772181592_SVGID_6__focus",
    points: "39,37 31.986,37 37.76,27 39,27"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#5772181592_SVGID_3__focus",
    className: "stshockcolor",
    style: {
      fill: "#EA7A2F",
      overflow: "visible"
    },
    "data-st": "fill:#EA7A2F;;overflow:visible;"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "5772181592_SVGID_4__focus"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#5772181592_SVGID_3__focus",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st6",
    style: {
      clipPath: "url(#5772181592_SVGID_4__focus)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    className: "st2",
    style: {
      opacity: 0.15
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#5772181592_SVGID_5__focus",
    className: "st1",
    style: {
      fill: "#7D1CC7"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#5772181592_SVGID_5__focus",
    className: "st8",
    style: {
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st7",
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#5772181592_SVGID_6__focus",
    className: "st4",
    style: {
      fill: "#F7D11A"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#5772181592_SVGID_6__focus",
    className: "st9",
    style: {
      opacity: 0.7,
      fill: "#FFFFFF"
    }
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscover);
export default __webpack_public_path__ + "static/media/discover.b527d452cbb6e5d4708f54b29351958a.svg";
export { ForwardRef as ReactComponent };